import routes from './appConfiguration.routes';

export const appConfigurationModule = {
    routes
};